import React from 'react';
import BCPGuideSection from '../components/BCPGuideSection';
import InitialResponseOverviewImage from '../assets/images/initial-response/1_3_shodoutaiou_fukan.png';
import FloodResponseOverviewImage from '../assets/images/initial-response/1-3_suigai_shodoutaiou.png';
import InfectionResponseOverviewImage from '../assets/images/initial-response/1_3_kansensho_taiouhyou.png';
import type { BCPSectionConfig } from './bcpFieldConfig';

export const INITIAL_RESPONSE_SECTIONS: BCPSectionConfig[] = [
  {
    id: 'earthquake',
    title: '地震',
    fields: [
      {
        id: 'earthquakeGuidelines',
        label: '1-1 行動指針',
        type: 'textarea',
        minHeight: 'small',
        defaultValue: [
          '①従業員・来客者の安全確保を最優先とする',
          '②安否確認を直ちに行う',
          '③情報を集約し、災害対策本部を立ち上げる',
          '④緊急対策本部の指示のもと重要業務を進める',
        ].join('\n'),
        placeholder: '行動指針を入力してください',
        aiConsult: true,
      },
      {
        id: 'earthquakeResponse',
        label: '1-2 初動対応サマリー',
        type: 'textarea',
        minHeight: 'large',
        defaultValue:
          '【ステージ1：発災・BCP発動フェーズ】\n・社員個人：安全確保、家族との連絡確保、状況に応じて避難の実施\n・初動対応チーム：社員の安否確認を実施、応急対応措置\n・緊急対策本部：対策本部の設置、地震に関する情報の収集、被害状況の収集\n\n【ステージ2：事業再開フェーズ】\n・社員個人：状況に応じて出社\n・復旧対応チーム：情報集約（社員の出社可否・自社資源の使用可否等）\n・緊急対策本部：収集した情報をもとに自社事業への影響分析、今後の方針等に関する情報発信\n\n【ステージ3：業務回復フェーズ】\n・社員個人：状況に応じて出社、テレワークの実施\n・緊急対策本部：重要業務を現地復旧（困難な場合は、現地復旧以外の戦略）\n\n【ステージ4：全面回復フェーズ】\n・社員個人：通常勤務へ移行\n・緊急対策本部：全業務の順次回復、緊急対策本部は適宜解散',
        placeholder: '初動対応サマリーを入力してください',
        aiConsult: true,
        guide: {
          content: (
            <div>
              <h4 className="font-medium mb-2" style={{ color: '#0D357F', fontSize: '14px' }}>
                初動対応俯瞰表(地震)
              </h4>
              <p className="text-sm text-gray-700 mb-2">
                地震発生時の初動対応は、4つのステージ(ステージ1「BCP発動フェーズ」、ステージ2「事業再開フェーズ」、ステージ3「業務回復フェーズ」、ステージ4「全面回復ステージ」)からなり、それぞれのステージにおいて、「誰が」「何をするか」を初動対応俯瞰表で整理しています。ダウンロード後に自社の状況に合わせて、適宜、修正してください。
              </p>
              <a href={InitialResponseOverviewImage} target="_blank" rel="noopener noreferrer">
                <img src={InitialResponseOverviewImage} alt="初動対応俯瞰表(地震)" style={{ width: '429px', height: '240px', marginTop: '8px', cursor: 'pointer' }} />
              </a>
            </div>
          ),
        },
      },
    ],
  },
  {
    id: 'flood',
    title: '水害',
    fields: [
      {
        id: 'floodGuidelines',
        label: '1-1 行動指針',
        type: 'textarea',
        minHeight: 'small',
        defaultValue:
          '水害のリスクは「従業員が帰宅（出社）できない」、「事業所への被害」が想定される。早め早めに情報収集を進め、「社員の安全」を第一とした対応を基本とする。',
        placeholder: '行動指針を入力してください',
        aiConsult: true,
      },
      {
        id: 'floodResponse',
        label: '1-2 初動対応サマリー',
        type: 'textarea',
        minHeight: 'large',
        defaultValue:
          '【ステージ1：自然災害の発生】\n・社員個人：自宅・通勤途上付近の避難所の確認\n・初動対応チーム：備蓄品や設備の点検、自然災害に関する情報収集\n・緊急対策本部：状況に応じて対策本部の設置、出社方針や帰宅方針の検討\n\n【ステージ2：地域で被害の恐れ】\n・社員個人：テレワークの準備\n・初動対応チーム：状況に応じて浸水防止措置や設備の保護\n・緊急対策本部：対策本部の設置、状況に応じて出社制限を指示\n\n【ステージ3：事業所で被害の恐れ】\n・社員個人：状況に応じて避難の実施、テレワークの準備\n・初動対応チーム：浸水防止措置、設備の保護\n・緊急対策本部：状況に応じて業務の一時停止や縮小\n\n【ステージ4：事業所で被害が発生】\n・社員個人：状況に応じて避難の実施、テレワークの実施\n・初動対応チーム：安否確認の実施、社会インフラの被害や復旧に関する情報の収集\n・緊急対策本部：状況に応じて重要業務以外の業務を停止\n\n【ステージ5：深刻な被害が発生】\n・社員個人：状況に応じて避難の実施、テレワークの実施\n・復旧対応チーム：被害設備の復旧手配、自社資源の使用可否や復旧時期に関する情報の収集\n・緊急対策本部：重要業務を現地復旧（困難な場合は、現地以外の復旧戦略）\n\n【ステージ6：終息段階】\n・社員個人：通常勤務へ移行\n・緊急対策本部：全業務の順次回復、緊急対策本部は適宜解散',
        placeholder: '初動対応サマリーを入力してください',
        aiConsult: true,
        guide: {
          content: (
            <div>
              <h4 className="font-medium mb-2" style={{ color: '#0D357F', fontSize: '14px' }}>
                初動対応俯瞰表(水害)
              </h4>
              <p className="text-sm text-gray-700 mb-2">
                水害発生時の初動対応は、6つのステージ(ステージ1〜5と「終息期」)からなり、それぞれのステージにおいて、「誰が」「何をするか」を初動対応俯瞰表で整理しています。ダウンロード後に自社の状況に合わせて、適宜、修正してください。
              </p>
              <a href={FloodResponseOverviewImage} target="_blank" rel="noopener noreferrer">
                <img src={FloodResponseOverviewImage} alt="初動対応俯瞰表(水害)" style={{ width: '409px', height: '364px', marginTop: '8px', cursor: 'pointer' }} />
              </a>
            </div>
          ),
        },
      },
    ],
  },
  {
    id: 'infection',
    title: '感染症',
    fields: [
      {
        id: 'infectionGuidelines',
        label: '1-1 行動指針',
        type: 'textarea',
        minHeight: 'small',
        defaultValue:
          '①「地震」、「水害」よりも長期戦を見据え、情報収集体制と予防体制を整える。\n②「社員が柔軟な勤務できる体制」や「テレワークができる体制」を整える。',
        placeholder: '行動指針を入力してください',
        aiConsult: true,
      },
      {
        id: 'infectionResponse',
        label: '1-2 初動対応サマリー',
        type: 'textarea',
        minHeight: 'large',
        defaultValue:
          '【ステージ1：海外発生】\n・社員個人：感染防止行動（咳エチケット、マスク着用、手洗い励行等）\n・初動対応チーム：備蓄品のメンテナンス、執務ルールの確認、海外の発生状況の把握\n・緊急対策本部：対策本部の設置、状況に応じて業務の前倒し遂行\n\n【ステージ2：国内発生】\n・社員個人：感染防止行動の徹底、不要不急の外出自粛、テレワークの準備\n・初動対応チーム：執務ルール（マスク着用、アクリル板設置、消毒体制等）の実施\n・緊急対策本部：自社事業への影響分析\n\n【ステージ3：地域発生】\n・社員個人：感染予防行動の徹底、不要不急の外出の自粛、テレワークの実施\n・初動対応チーム：体温測定・記録\n・緊急対策本部：重要業務は原則遂行、重要業務以外は状況に応じて一時停止や縮小\n\n【ステージ4：感染発生】\n・社員個人：感染予防行動の徹底、不要不急の外出の自粛、テレワークの実施\n・初動対応チーム：事業所内の感染拡大措置（隔離・消毒）、出社可否に関する情報収集\n・緊急対策本部：重要業務は原則遂行、重要業務以外は状況に応じて一時停止や縮小\n\n【ステージ5：感染拡大】\n・社員個人：感染予防行動の徹底、不要不急の外出の自粛、テレワークの実施\n・初動対応チーム：事業所内の感染拡大措置（隔離・消毒）、出社可否に関する情報収集\n・緊急対策本部：重要業務を現地復旧（困難な場合は、現地以外の復旧戦略）、重要業務以外は原則停止\n\n【ステージ6：終息期】\n・社員個人：通常勤務へ移行\n・緊急対策本部：全業務の順次回復、緊急対策本部は適宜解散',
        placeholder: '初動対応サマリーを入力してください',
        aiConsult: true,
        guide: {
          content: (
            <div>
              <h4 className="font-medium mb-2" style={{ color: '#0D357F', fontSize: '14px' }}>
                初動対応俯瞰表(感染症)
              </h4>
              <p className="text-sm text-gray-700 mb-2">
                感染症発生時の初動対応は、6つのステージ(ステージ1〜5と「終息期」)からなり、それぞれのステージにおいて、「誰が」「何をするか」を初動対応俯瞰表で整理しています。修正が必須の項目はありませんが、自社の状況に合わせて、適宜、修正してください。
              </p>
              <a href={InfectionResponseOverviewImage} target="_blank" rel="noopener noreferrer">
                <img src={InfectionResponseOverviewImage} alt="初動対応俯瞰表(感染症)" style={{ width: '407px', height: '342px', marginTop: '8px', cursor: 'pointer' }} />
              </a>
            </div>
          ),
        },
      },
    ],
  },
];

export type InitialResponseFieldId =
  (typeof INITIAL_RESPONSE_SECTIONS)[number]['fields'][number]['id'];
